import styled from 'styled-components';
export const ErrorPageTemplateWrapper = styled.div`
  padding-top: 107px;
  margin-left: 460px;
`;
export const ErrorPageTemplateHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;
export const ErrorPageTemplateHeaderText = styled.div`
  width: 222px;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0.1;
  color: #353b60;
`;
export const ErrorPageTemplateHeaderLink = styled.a`
  text-decoration: none;
  color: currentColor;
`;
export const ErrorPageTemplateMediumText = styled.div`
  width: 632px;
  color: #353b60;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.1px;
  margin-bottom: 24px;
`;
export const ErrorPageTemplateSmallText = styled.div`
  width: 550px;
  color: #353b60;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.1px;
  margin-bottom: 24px;
`;
export const ErrorPageTemplateErrorCodeText = styled.div`
  color: #353b60;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.1px;
  font-weight: 600;
`;